<template>
  <div class="">
    <div class="nav__wrapper" :class="{ 'top-snackbar' :messages.length > 0}">
      <!-- {% include "components/common/snackbar.twig" %} -->
      
      <div class="grid">        
        <div class="col nav__inner pb-0 pt-0">
          <router-link                       
            class="nav__logo"
            :to="{name:'root'}"            
          >
            <!-- <a class="nav__logo"> -->
            
            <div class="logo logo--blue">
              <div class="icon">                
                <svg width="214px" height="130px" viewBox="0 0 214 130" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>9B95A01D-808B-4EAC-B3B2-A80F7EB94386</title>
                  <defs>
                    <polygon id="path-1" points="0.0003 0.9342 213.08 0.9342 213.08 129 0.0003 129" />
                    <polygon id="path-3" points="1.42108547e-14 129.066 213.08 129.066 213.08 1 1.42108547e-14 1" />
                  </defs>
                  <g id="Design-system" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Brand" transform="translate(-371.000000, -193.000000)">
                      <g id="logo" transform="translate(56.000000, 126.000000)">
                        <g id="Logo" transform="translate(315.000000, 67.000000)">
                          <g id="Group-3" transform="translate(0.000000, 0.066000)">
                            <mask id="mask-2" fill="white">
                              <use xlink:href="#path-1" />
                            </mask>
                            <g id="Clip-2" />
                            <path id="Fill-1" d="M106.6563,5.8842 C106.6563,5.8842 106.8383,0.9342 120.8623,0.9342 L213.0803,0.9342 L213.0803,124.6832 L120.8623,124.6832 C106.8383,124.6832 106.6563,129.0002 106.6563,129.0002 C106.6563,129.0002 106.2433,124.6832 92.2183,124.6832 L0.0003,124.6832 L0.0003,0.9342 L92.2183,0.9342 C106.2433,0.9342 106.6563,5.8842 106.6563,5.8842" fill="#1D1D1B" mask="url(#mask-2)" />
                          </g>
                          <polygon id="Fill-4" fill="#FEFEFE" points="44.8145 69.0884 37.2635 49.9884 37.2635 69.0884 27.3805 69.0884 27.3805 29.8894 37.2635 29.8894 37.2635 47.9344 44.5385 29.8894 55.0315 29.8894 46.0905 49.0444 55.5855 69.0884" />
                          <path id="Fill-6" d="M75.2266,69.0884 L64.6776,69.0884 L55.6276,29.8894 L65.7336,29.8894 C66.9536,36.2194 68.3976,42.6054 69.1756,48.9884 C69.6196,52.5434 69.7866,56.0954 70.0086,59.6504 C70.3406,53.8754 70.8406,48.1004 71.9516,42.4374 L74.3936,29.8894 L84.5546,29.8894 L75.2266,69.0884 Z" fill="#FEFEFE" />
                          <mask id="mask-4" fill="white">
                            <use xlink:href="#path-3" />
                          </mask>
                          <g id="Clip-9" />
                          <path id="Fill-8" d="M97.983,33.666 L104.924,33.666 L104.924,26.226 L97.983,26.226 L97.983,33.666 Z M97.874,48.489 C97.263,44.824 97.041,41.105 96.598,37.441 C96.097,42.381 95.707,47.378 94.875,52.265 L98.484,52.265 L97.874,48.489 Z M88.379,33.666 L95.319,33.666 L95.319,26.226 L88.379,26.226 L88.379,33.666 Z M101.093,69.088 L99.649,59.982 L93.708,59.982 L92.209,69.088 L81.661,69.088 L89.213,34.332 L95.984,34.332 L95.984,29.889 L97.318,29.889 L97.318,34.332 L104.202,34.332 L111.641,69.088 L101.093,69.088 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <polygon id="Fill-10" fill="#FEFEFE" mask="url(#mask-4)" points="112.916 69.0884 112.916 29.8894 122.744 29.8894 122.744 61.0374 134.624 61.0374 134.624 69.0884" />
                          <polygon id="Fill-11" fill="#FEFEFE" mask="url(#mask-4)" points="136.9551 69.0884 136.9551 29.8894 146.7811 29.8894 146.7811 61.0374 158.6641 61.0374 158.6641 69.0884" />
                          <path id="Fill-12" d="M172.8184,69.7554 C170.5434,69.7554 168.1564,69.4204 166.0994,68.4784 C161.1594,66.3104 160.1044,62.4254 160.1044,57.3734 C160.1044,56.8174 160.1044,56.2624 160.1604,55.7074 L169.6544,55.7074 C169.6544,58.2614 169.3774,62.1474 172.9864,62.1474 C174.8734,62.1474 176.0394,60.8154 176.0394,58.9824 C176.0394,56.0954 171.7634,54.0414 169.6544,52.7094 C164.5474,49.5444 160.6594,46.9904 160.6594,40.3824 C160.6594,32.8874 165.8224,29.2244 172.9294,29.2244 C177.9814,29.2244 182.9244,31.0554 184.3124,36.3854 C184.6454,37.6624 184.7014,39.0514 184.7014,40.3824 L184.7014,41.4384 L175.4844,41.4384 C175.4844,39.2164 175.3734,36.6634 172.4854,36.6634 C170.8754,36.6634 169.9314,37.7184 169.9314,39.2734 C169.9314,39.9944 170.2094,40.5494 170.5974,41.1614 C171.3754,42.3264 175.7054,44.9914 177.1484,45.9364 C181.9234,49.0994 185.6994,51.7654 185.6994,58.0394 L185.6994,58.2054 C185.6994,65.9234 180.0364,69.7554 172.8184,69.7554" fill="#FEFEFE" mask="url(#mask-4)" />
                          <polygon id="Fill-13" fill="#FEFEFE" mask="url(#mask-4)" points="36.1997 78.0474 36.1997 94.7854 30.9287 94.7854 30.9287 78.0474 27.3557 78.0474 27.3557 73.7574 39.7747 73.7574 39.7747 78.0474" />
                          <polygon id="Fill-14" fill="#FEFEFE" mask="url(#mask-4)" points="40.904 94.785 46.175 94.785 46.175 73.757 40.904 73.757" />
                          <path id="Fill-15" d="M56.6587,81.6499 C56.6587,80.9349 56.5697,79.1189 56.0927,78.5829 C55.6467,78.1069 55.0507,77.9879 54.4247,77.9879 L53.6207,77.9879 L53.6207,90.5859 L54.6047,90.5859 C56.5397,90.5859 56.6587,88.7679 56.6587,87.2799 L56.6587,81.6499 Z M61.9597,86.5049 C61.9597,91.7769 60.7397,94.7859 54.9027,94.7859 L48.3797,94.7859 L48.3797,73.7569 L54.2757,73.7569 C57.5527,73.7569 60.2917,74.2339 61.5127,77.6889 C61.9307,78.8799 61.9907,80.2499 61.9907,81.5019 C61.9907,83.1699 61.9597,84.8369 61.9597,86.5049 L61.9597,86.5049 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-16" d="M73.187,94.7857 C71.847,91.1817 70.447,87.6077 69.375,83.9137 C68.898,82.2757 68.511,80.6387 68.094,78.9997 C68.302,80.4587 68.54,81.9197 68.66,83.4077 C68.989,87.1607 68.989,91.0327 69.077,94.7857 L63.924,94.7857 L63.924,73.7577 L69.881,73.7577 L71.817,78.9997 C73.038,82.3357 74.051,85.7307 75.034,89.1557 C74.498,85.9097 74.2,82.6637 74.11,79.3567 L73.96,73.7577 L79.114,73.7577 L79.114,94.7857 L73.187,94.7857 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <polygon id="Fill-17" fill="#FEFEFE" mask="url(#mask-4)" points="81.317 94.785 86.587 94.785 86.587 73.757 81.317 73.757" />
                          <path id="Fill-18" d="M98.0532,94.7857 C96.7142,91.1817 95.3142,87.6077 94.2402,83.9137 C93.7662,82.2757 93.3772,80.6387 92.9602,78.9997 C93.1692,80.4587 93.4072,81.9197 93.5272,83.4077 C93.8542,87.1607 93.8542,91.0327 93.9432,94.7857 L88.7902,94.7857 L88.7902,73.7577 L94.7482,73.7577 L96.6832,78.9997 C97.9052,82.3357 98.9172,85.7307 99.8992,89.1557 C99.3652,85.9097 99.0672,82.6637 98.9762,79.3567 L98.8282,73.7577 L103.9812,73.7577 L103.9812,94.7857 L98.0532,94.7857 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-19" d="M115.0293,80.5484 C114.9703,79.2084 114.9393,77.7474 113.1813,77.7474 C112.6473,77.7474 112.3183,77.8674 111.9313,78.2544 C111.1873,79.0304 111.2763,81.8594 111.2763,82.9314 C111.2763,84.4214 111.2473,85.9094 111.2473,87.3684 C111.2473,88.6794 111.2763,90.8534 113.0933,90.8534 C114.5523,90.8534 115.1193,89.6914 115.1193,88.3824 C115.1193,87.7554 115.0583,87.1604 115.0583,86.5344 L112.8263,86.5344 L112.8263,82.3644 L120.2713,82.3644 L120.2713,94.7854 L116.0133,94.7854 L116.0133,92.4024 C115.0883,94.2494 113.5993,95.1424 111.5453,95.1424 C107.0173,95.1424 106.3033,91.4794 106.0333,87.8164 C105.9453,86.5054 105.9153,85.1654 105.9153,83.8544 C105.9153,82.1874 105.8863,79.2374 106.3633,77.6894 C107.3453,74.3824 110.1153,73.4004 113.3003,73.4004 C116.1613,73.4004 118.6923,74.2944 119.7953,77.1524 C120.1813,78.1944 120.2413,79.4444 120.3003,80.5484 L115.0293,80.5484 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-20" d="M129.8242,83.7359 C129.4982,81.7689 129.3792,79.7749 129.1402,77.8079 C128.8732,80.4589 128.6632,83.1399 128.2172,85.7589 L130.1542,85.7589 L129.8242,83.7359 Z M131.5522,94.7859 L130.7792,89.9009 L127.5922,89.9009 L126.7872,94.7859 L121.0972,94.7859 L125.6562,73.7569 L132.7152,73.7569 L137.2422,94.7859 L131.5522,94.7859 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-21" d="M144.3574,78.0474 L143.2854,78.0474 L143.2854,82.4244 L144.4484,82.4244 C145.9084,82.4244 146.3234,81.5904 146.3234,80.2494 C146.3234,78.8514 145.8774,78.0474 144.3574,78.0474 L144.3574,78.0474 Z M146.9204,94.7854 C146.1754,93.4444 146.2344,91.4794 146.2044,89.9604 C146.1754,88.5614 146.3824,86.7434 144.4484,86.7434 L143.2854,86.7434 L143.2854,94.7854 L138.0454,94.7854 L138.0454,73.7574 L144.7144,73.7574 C149.1534,73.7574 151.4474,74.8904 151.4474,79.6854 C151.4474,81.8284 151.0584,84.0034 148.6184,84.5094 C151.5664,85.3144 151.2674,87.8164 151.3574,90.2884 C151.4174,91.9554 151.5074,93.2674 152.3394,94.7854 L146.9204,94.7854 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-22" d="M162.8516,94.7857 C161.5116,91.1817 160.1116,87.6077 159.0386,83.9137 C158.5626,82.2757 158.1756,80.6387 157.7586,78.9997 C157.9666,80.4587 158.2056,81.9197 158.3246,83.4077 C158.6536,87.1607 158.6536,91.0327 158.7426,94.7857 L153.5896,94.7857 L153.5896,73.7577 L159.5446,73.7577 L161.4826,78.9997 C162.7026,82.3357 163.7146,85.7307 164.6996,89.1557 C164.1626,85.9097 163.8656,82.6637 163.7756,79.3567 L163.6246,73.7577 L168.7796,73.7577 L168.7796,94.7857 L162.8516,94.7857 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                          <path id="Fill-23" d="M178.3086,83.7359 C177.9816,81.7689 177.8616,79.7749 177.6226,77.8079 C177.3556,80.4589 177.1466,83.1399 176.6996,85.7589 L178.6366,85.7589 L178.3086,83.7359 Z M180.0356,94.7859 L179.2616,89.9009 L176.0746,89.9009 L175.2706,94.7859 L169.5806,94.7859 L174.1396,73.7569 L181.1976,73.7569 L185.7246,94.7859 L180.0356,94.7859 Z" fill="#FEFEFE" mask="url(#mask-4)" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <!-- {% 
                include 'components/icon.twig' with { 
                  icon: 'logo',
                } 
              %} -->
              </div>
            </div>
          </router-link>

          
          <template v-if="!authorized">
            <div class="nav__login nav__login--mobile">
              <div class="">
                <label class="nav__item__link" for="mega-nav-5">Logga in</label>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="nav__logout nav__logout--mobile" @click="(authorized)?logout():''">
              <div class="nav__user">
                <div class="nav__user__icon">
                  <v-icon color="primary">
                    mdi-account-outline
                  </v-icon> 
                </div>
                <div class="nav__user__id">
                  <p v-if="$vuetify.breakpoint.xs" class="lead">
                    {{ user.name | truncate(20,'...') }} 
                  </p>
                  <p v-else class="lead">
                    {{ user.name }} 
                  </p>
                </div>
              </div>
              <div class="nav__user__logout js-logout">
                <sign-in-icon class="icon" />
                <p class="lead">
                  Logga ut
                </p>                  
              </div>
            </div>
          </template>

          <label class="nav__mobile--open js-menu">
            <div class="grid nav__mobile__menu">
              <div class="nav__mobile__menutext">
                <p>Meny</p>
              </div>
              <v-icon dark>menu</v-icon>
            </div>
          </label>          

          <!-- Nav desktop -->
          <div class="nav__desktop">
            <ul class="nav">
              <NavMainItem v-for="(menuItem,index) in menuForRole" :key="index" :menu="menuItem" />        
            </ul>
       
            <template v-if="!authorized">
              <div class="nav__login">
                <div class="nav__user">
                  <label class="" for="mega-nav-5">
                    <v-icon color="primary">mdi-account-outline</v-icon> 
                  </label>
                </div>
                <label class="nav__item__link" for="mega-nav-5">
                  Logga in
                </label>
              </div>
            </template>
            <template v-else>
              <div class="nav__logout" @click="(authorized)?logout():''">
                <div class="nav__user">
                  <div class="nav__user__icon">
                    <v-icon>mdi-account-outline</v-icon> 
                  </div>
                  <div class="nav__user__id">
                    <p class="lead">
                      {{ user.name }}
                    </p>
                  </div>
                </div>
                <!-- <div class="nav__user__time">
                  <span class="lead">Tid kvar:</span>
                  <span class="lead js-time">14:55</span>
                </div> -->
                <div class="nav__user__logout js-logout">
                  <sign-in-icon class="icon" />
                  <p class="lead">
                    Logga ut
                  </p>
                </div>
              </div>
            </template>            
          </div>

          <div class="nav__mobile" style="top: 45px">
            <ul class="nav" />
          </div> 
        </div>
      </div>
    </div>

    <div class="nav__mega__wrapper" :style="top">
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <NavMegaItem v-for="(mega,index) in menuWithChildren" :key="index" :menu="mega" />
      </div>
      <div class="nav__mega__smallwrapper nav__mega__smallwrapper--more-top">
        <div id="nav-mega-login" class="nav__mega__container">
          <input
            id="mega-nav-5"
            type="radio"
            name="mega-nav"
            class="nav__mega__trigger"
          >
          <div class="nav__mega login__wrapper">
            <Login v-if="!authorized" @AUTHORIZED="onAuthorized" />            
          </div>
        </div>
      </div>
      <div class="js-stack-navigation">
        <div class="nav -stack" :class="{'-open': mobileMenuOpen}">
          <div class="nav__wrapper">
            <div class="nav__content">              
              <header class="nav__bar">
                <template v-if="!authorized">
                  <div class="nav__login nav__login--mobile">
                    <div class="nav__user">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon" aria-hidden="true"><use xlink:href="https://kvallstidningarna.strateg.dev/app/themes/kvallstidningarna/dist/icons/sprite.svg#user" /></svg>
                    </div><label class="nav__item__link" for="mega-nav-5">Logga in</label>
                  </div>
                </template>
                <template v-else>
                  <div class="nav__logout nav__logout--mobile">
                    <div class="nav__user">
                      <div class="nav__user__icon">
                        <v-icon>person</v-icon> 
                      </div>
                      <div class="nav__user__id">
                        <p v-if="$vuetify.breakpoint.xs" class="lead">
                          {{ user.name | truncate(20,'...') }} 
                        </p>
                        <p v-else class="lead">
                          {{ user.name }} 
                        </p>
                      </div>
                    </div>
                    <div class="nav__user__logout js-logout">
                      <sign-in-icon class="icon" />
                      <p class="lead">
                        Logga ut
                      </p>                      
                    </div>
                  </div>
                </template>
              </header>
              
              <div class="nav__controls">
                <div class="nav__controlsClose nav__mobile__menu" @click.stop="openHideMobileNav">
                  <div class="nav__mobile__menutext">
                    <p>Meny</p>
                  </div>
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </div>
              </div>
              
              <div class="nav__panes">
                <!-- <div class="nav__pane" style="transform: translateX(-40%);">
                  <ul class="nav__list">
                    <template v-for="(menuItem,idx) in menu">
                      <li :key="idx" level="1" class="nav__item">
                        <router-link 
                          v-if="menuItem.route !== undefined"
                          class="nav__link"
                          :to="menuItem.route"
                          :title="menuItem.title"
                        >
                          {{ menuItem.title }}
                        </router-link>
                        <a v-else-if="menuItem.link !== undefined"
                           class="nav__link"
                           :href="menuItem.link"
                           :title="menuItem.title" 
                           :for="menuItem.id"
                        >
                          {{ menuItem.title }}
                        </a>
                        <label v-else 
                               class="nav__link"
                               href="#" 
                               :title="menuItem.title" 
                               :for="menuItem.id"
                        >
                          {{ menuItem.title }}
                        </label>                        
                      </li>
                    </template>               
                  </ul>
                </div> -->
                
                <div class="nav__pane">
                  <ul class="nav__list">
                    <template v-for="(menuItem,idx) in menuForRole">
                      <li :key="idx" class="nav__item">
                        <router-link 
                          v-if="menuItem.children === undefined && menuItem.route !== undefined"
                          class="nav__link"
                          :to="menuItem.route"
                          :title="menuItem.title"
                        >
                          {{ menuItem.title }}
                        </router-link>
                        <a v-else-if="menuItem.children === undefined && menuItem.link !== undefined"
                           class="nav__link"
                           :href="menuItem.link"
                           :title="menuItem.title"                            
                        >
                          {{ menuItem.title }}
                        </a>
                        <label v-else 
                               class="nav__link"
                               href="#" 
                               :title="menuItem.title" 
                        >
                          {{ menuItem.title }}
                        </label>
                        <!-- <a href="/" class="nav__link">{{ menuItem.title }}</a>                       -->
                      </li>
                      <ul v-if="menuItem.children !== undefined" :key="idx+'-1'">
                        <li v-for="(childItem,childIdx) in menuItem.children" :key="childIdx" level="2" class="nav__item -nested">
                          <router-link 
                            v-if="childItem.children === undefined && childItem.route !== undefined"
                            class="nav__link"
                            :to="childItem.route"
                            :title="childItem.title"
                          >
                            {{ childItem.title }}
                          </router-link>
                          <a v-else-if="childItem.children === undefined && childItem.link !== undefined"
                             class="nav__link"
                             :href="childItem.link"
                             :title="childItem.title" 
                             :for="childItem.id"
                          >
                            {{ childItem.title }}
                          </a>
                          <label v-else 
                                 class="nav__link"
                                 href="#" 
                                 :title="childItem.title" 
                                 :for="childItem.id"
                          >
                            {{ childItem.title }}
                          </label>
                          <!-- <a href="http://verktygsladan.kvallstidningarna.se/returrapportera" class="nav__link">{{ childItem.title }}</a> -->
                          <ul v-if="childItem.children !== undefined" :key="childIdx+'-1'">
                            <li v-for="(childMenuItem,childMenuIdx) in childItem.children" :key="childMenuIdx" level="2" class="nav__item -nested">
                              <router-link 
                                v-if="childMenuItem.children === undefined && childMenuItem.route !== undefined"
                                class="nav__link"
                                :to="childMenuItem.route"
                                :title="childMenuItem.title"
                              >
                                {{ childMenuItem.title }}
                              </router-link>
                              <a v-else-if="childMenuItem.children === undefined && childMenuItem.link !== undefined"
                                 class="nav__link"
                                 :href="childMenuItem.link"
                                 :title="childMenuItem.title" 
                                 :for="childMenuItem.id"
                              >
                                {{ childMenuItem.title }}
                              </a>
                              <label v-else 
                                     class="nav__link"
                                     href="#" 
                                     :title="childMenuItem.title" 
                                     :for="childMenuItem.id"
                              >
                                {{ childMenuItem.title }}
                              </label>
                              <!-- <a href="http://verktygsladan.kvallstidningarna.se/returrapportera" class="nav__link">{{ childItem.title }}</a> -->
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </template>
                    
                    <!-- <ul v-if="menuItem.children !== undefined">
                      <li v-for="(childItem,idx) in menuItem.children" :key="idx" level="2" class="nav__item -nested">
                        <a href="http://verktygsladan.kvallstidningarna.se/returrapportera" class="nav__link">{{ childItem.title }}</a>
                      </li>
                    </ul> -->
                    <!-- <li id="410" level="1" class="nav__item nav__item__current">
                      <a href="http://verktygsladan.kvallstidningarna.se/returrapportera" class="nav__link">Returrapportera</a>                      
                    </li>
                    <ul>
                      <li level="2" class="nav__item -nested">
                        <a href="http://verktygsladan.kvallstidningarna.se/returrapportera" class="nav__link">Returrapportera</a>
                      </li>
                      <li level="2" class="nav__item -nested">
                        <a href="http://kvallstidningarna.se/" class="nav__link">Historik</a>
                      </li>
                      <li level="2" class="nav__item -nested">
                        <a href="http://verktygsladan.kvallstidningarna.se/buntinneh%C3%A5ll" class="nav__link">Buntinnehåll</a>
                      </li>
                    </ul> -->
                  </ul>
                </div>
                <div class="nav__pane" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//let megaNav = require('@/scripts/components/megaNav')
import '@/scripts/components/mobileNav.js'
import Login from '@/components/web/Login'
import { APP_USER} from '@/store/appStates'
import { SET_USER,REMOVE_LAST_SELECTED_BUNDLE_ID} from '@/store/appMutations'
import { mapState, mapMutations } from 'vuex'
import { setAuthHeader } from '@/backend/axios'
import * as rs from '@/model/reportState'
import SignInIcon from '@/components/icons/SignInIcon'
import api from '@/backend/api'
import log from '@/logger'
import settings from '@/model/settings'
import { userHasRole } from '@/model/roles'
import NavMainItem from '@/components/web/NavigationMainItem'
import NavMegaItem from '@/components/web/NavigationMegaItem'


export default {
  name:'AdminNavigation',
  components:{Login,SignInIcon,NavMainItem, NavMegaItem},
   props:{
     allMessages:{
       type: Array,
       required: true,
     },
    },
  data(){    
    return {
      currentPageElement:'',
      config: {
        get triggers() {
          return this.triggerCN
            .map(CN => [...document.querySelectorAll(`.${CN}`)])
            .reduce((acc, current) => [...acc, ...current])
        },
        get radios() {
          return this.radioCN
            .map(CN => [...document.querySelectorAll(`.${CN}`)])
            .reduce((acc, current) => [...acc, ...current])
        },
        triggerCN: ['nav__mega'],
        radioCN: ['nav__mega__trigger'],
        megaContainerCN: ['nav__mega__container'],
        bodyCN: 'meganav-open',
      },
       reportState: rs,
       messages:[],
       mobileMenuOpen:false,
       menu:[
          {
            id:'',
            title:'Start',
            route:
              {
                name:'start'
              }
          },
          {
            id:'mega-nav-1',
            title:'Admin',
            role:'admin',
            route:
              {
                name:'admin'
              }
          },
          {
            id:'mega-nav-2',
            title:'Kundtjänst',
            role:'admin',
            route:
            {
              name:'kundtjanst',
            },		
            children:
            [
              {
                title:'Meddelanden',
                route:
                {
                  name:'messages',                      
                },			
              },
              {
                title:'Dagens produkter',
                route:
                {
                  name:'dailyproducts',                      
                },			
              },
              {
                title:'Buntar',                
                route:
                {
                  name:'bundles',
                },			
              },
              {
                title:'Helgspärr',                
                route:
                {
                  name:'holidays',
                },			
              },
              {
                title:'Produkt Information',                
                route:
                {
                  name:'products',
                },			
              },
              {
                title:'Fakturering',                
                route:
                {
                  name:'invoice',
                },			
              },
              {
                title:'Garantibelopp',                
                route:
                {
                  name:'guarantees',
                },			
              },
              {
                title:'MiniDeb',                
                route:
                {
                  name:'minideb',
                },			
              },
              // {
              //   title:'Reklamationer',
              //   route:
              //   {
              //     name:'reklamationer',
              //   },			
              // },
              // {
              //   title:'Historik',
              //   route:
              //   {
              //     name:'historik',					
              //   },			
              // },{
              //   title:'Buntinnehåll',
              //   route:
              //   {
              //     name:'buntsok',				
              //   },			
              // }
            ]
          },
          {
            id:'mega-nav-3',
            title:'Distribution',
            role:'admin,sales,utb',
            link:settings.route.www+'/utb/',              
            children:
            [
                  {
                    title:'Distribution',
                    route:
                    {
                      name:'distribution',                      
                    },			
                  },                 
                  // {
                  //   title:'Beställ returetiketter',
                  //   route:
                  //   {
                  //     name:'order',                      
                  //   },			
                  // },
                  // {
                  //   title:'Skriv ut nödetiketter',
                  //   route:
                  //   {
                  //     name:'nodetiketter',					
                  //   },			
                  // },
                  // {
                  //   title:'Mina returetiketter/block',                   			
                  //   route:
                  //   {
                  //     name:'buntblock',					
                  //   },	
                  // },
                  // {
                  //   title:'Tidningsjournal',
                  //    route:
                  //   {
                  //     name:'journal',					
                  //   },	                   			
                  // },
                  // // {
                  // //   title:'Tillfällig spärr',                   			
                  // // },
                  // // {
                  // //   title:'Önskad upplaga',                   			
                  // // },
                  // // {
                  // //   title:'Löpsedlar',                   			
                  // // },
                  // // {
                  // //   title:'Epost-faktura',                   			
                  // // },
                  // {
                  //   title:'Helgspärr',            
                  //   route:{
                  //     name:'helgsparr'
                  //   }       			
                  // },
                  // {
                  //   title:'Fakturor',     
                  //   route:
                  //   {
                  //     name:'faktura',					
                  //   },	               			
                  // },
                  //  {
                  //   title:'In- & utpriser',     
                  //   route:
                  //   {
                  //     name:'provision',					
                  //   },	               			
                  // },
                  // {
                  //   title:'Ägarbyte/Uppsägning',                   			
                  // },
                  // {
                  //   title:'Säsong',                   			
                  // },
                ]             
          },	
          // {
          //   id:'mega-nav-4',
          //   title:'Webbshop',
          //   link:settings.route.shop,            
          // },	    
          // {
          //   id:'',
          //   title:'Kontakt',
          //   link:settings.route.www+'/kontakt/'
          // },
          //  {
          //   id:'',
          //   title:'Hjälp',
          //   link:settings.route.www+'/sa-har-returrapporterar-du/',        
          //   target:'_blank'    
          // },	    
      ]
    }
  },
  computed: {
    ...mapState({      
      user:state => state[APP_USER],      
    }),
    menuForRole(){
      return this.menu.filter(m=>this.hasRole(m))
      
    },
    authorized(){
      if(this.user === undefined){
        return false
      }
      if(this.user.token !== undefined){
        setAuthHeader(this.user.token)
        return true
      }
      return false
    },
    hasMessages(){
      return this.allMessages.filter(m=>m.type !== 1).length > 0
    },
    alertMessages(){
      return this.allMessages.filter(m=>m.type !== 1)
    },
    menuWithChildren(){
      return this.menu.filter(p=>p.children !== undefined)
    },
    top(){
      if(this.hasMessages){
        let count = this.allMessages.filter(m=>m.type !== 1).length
        let top = 88 + (count * 47)
                
        return 'top:'+top+'px'
      }
      else{
        return 'top:88px'
      }
    }
  },
  watch: {
    authorized(value) {
      if (!value && settings.env === 'development') {
        this.$nextTick(() => this.showLogin())
      }
    },
  },
  mounted() {
    //megaNav.default.init()
    this.init()    
    
  },
  updated(){
    console.log('updated ' + this.$route.meta)
    if(this.$route.meta.showMenu !== undefined && this.$route.meta.showMenu === true){
      var main = document.querySelector('.v-main div.v-main__wrap')
      main.classList.add('pad-menu-open')
      var id = this.currentPageElement.getAttribute('for')
      this.config.radios.forEach(radio => {       
        if(radio.id === id){
          radio.checked = true
          document.body.classList.add(this.config.bodyCN)          
        }
      })
    }    
    this.$route.meta.showMenu = false
  },
  methods:{     
     ...mapMutations({    
      setUser: SET_USER,
      resetState:REMOVE_LAST_SELECTED_BUNDLE_ID,      
    }), 
    hasRole(menuItem){
      if(menuItem.role === undefined){
        return true
      }
      return userHasRole(this.user, menuItem.role.toLowerCase().split(','))
    },
    onAuthorized() {
     // this.loadMessages()
      this.hideNav()
      if(this.$route.path !== '/')
        {
          this.$router.replace('/')
        }
    },
    removeCurrentItem(){
      // eslint-disable-next-line no-restricted-syntax
      for (const item of document.querySelectorAll(
        '.nav__desktop ul.nav li.nav__item',
      )) {
        item.classList.remove('current-menu-item')
      }
    },

    restoreInitialCurrentItem(){
      if (this.currentPageElement) {
        this.currentPageElement.parentNode.classList.add('current-menu-item')
      }
      else{
        for (const item of  document.querySelectorAll('.nav__desktop ul.nav li.nav__item label',)) {
          if(item.title === this.$route.meta.title){
            item.parentNode.classList.add('current-menu-item')
            this.currentPageElement = item
          }          
         }
       
      }
    },

    hideNav(){
      this.removeCurrentItem()
      this.restoreInitialCurrentItem()

      this.config.radios.forEach(radio => {
        radio.checked = false // eslint-disable-line no-param-reassign
      })

      var main = document.querySelector('.v-main div.v-main__wrap')
      main.classList.remove('pad-menu-open')
      document.body.classList.remove(this.config.bodyCN)
      handleESC.stop()
    },

    showNav(e){
      this.removeCurrentItem()

      if (e && e.target && e.target.labels.length > 0) {
        const label = e.target.labels[0]
        label.parentNode.classList.add('current-menu-item')
        this.currentPageElement = label
      }      

      var main = document.querySelector('.v-main div.v-main__wrap')
      main.classList.add('pad-menu-open')
      document.body.classList.add(this.config.bodyCN)
      handleESC.init(() => this.hideNav())
    },

    handleClick({ e }){
      if (document.body.classList.contains(this.config.bodyCN) && (document.getElementById('mega-nav-5')!== null &&!document.getElementById('mega-nav-5').checked)){
         
         var mega= document.querySelectorAll(`.${this.config.megaContainerCN}`)
         var self = this
         mega.forEach(function (arrayItem) {
            if(arrayItem.contains(e.target)){
              self.hideNav()
            }           
        })        
      }
       
    },

    handleChange(e){
      if(!this.mobileMenuOpen){
        e.handled = true
      }
      let checked = false
      this.config.radios.forEach(radio => {
        if (radio.checked) checked = true
      })

      if (checked) {
        this.showNav(e)
      } else {
        this.hideNav()
      }
    },
    openHideMobileNav(){
      this.mobileMenuOpen = !this.mobileMenuOpen                    
    },

    showLogin(){
      const loginRadio = document.getElementById('mega-nav-5')
      if (loginRadio) {
        loginRadio.checked = true
        loginRadio.dispatchEvent(new Event('change'))
      }
    },

    loadMessages() {
      api.getMessages().then((resp) => {
        log.debug('Messages:', resp)
        this.messages = resp.data
      })
      .catch(error => {          
        log.debug('Errors:', error)
      })
    },       

   

    init(){
      this.currentPageElement = document.querySelector(
        '.nav__desktop ul.nav li.current-menu-item',
      )      
      document.querySelector('.js-menu').addEventListener('click', e => {
        this.openHideMobileNav({e})       
      })

      document.querySelectorAll('.js-stack-navigation .nav li.nav__item').forEach(item => {
        item.addEventListener('click', e => {
          this.openHideMobileNav({e})       
        })
      })
 
      if (this.config.triggers.length > 0) {
        // Close mobile nav if click on outside area
        document.addEventListener('click', e => this.handleClick({ e }))

        // // close login if click close icon
        // document.querySelector('.login-close').addEventListener('click', () => this.handleLoginBoxClose())

        // Add body class if nav is opens
        // In dev there is no www login to set the admin cookie, so open the login box at root.
        if (settings.env === 'development' && !this.authorized && this.$route.name === 'root') {
          const loginRadio = document.getElementById('mega-nav-5')
          if (loginRadio) {
            loginRadio.checked = true
          }
        }
        this.config.radios.forEach(radio => {
          radio.addEventListener('change', e => this.handleChange(e))

          let event
          if (typeof Event === 'function') {
            event = new Event('change')
          } else {
            event = document.createEvent('Event')
            event.initEvent('change', true, true)
          }

          radio.dispatchEvent(event)
        })
      }
    
      //this.loadMessages()
    },
    logout(){      
      this.resetState()              
      setAuthHeader(null)                
      this.setUser()   
      localStorage.removeItem('vuex')        
      //this.onAuthorized()          
      this.$router.push('/logout')
    },
  }
}

var handleESC = (() => {
  const stop = (callback = false) => {
    window.onkeyup = null

    if (callback !== false) {
      callback()
    }
  }

  const init = (callback = false) => {
    window.onkeyup = e => {
      switch (
        e.which // ESC
      ) {
        case 27:
          stop()
          if (callback !== false) {
            callback()
          }
          break
        default:
          break
      }
    }
  }

  return {
    init,
    stop,
  }
})()
</script>

<style lang="scss" scoped>  
  // @import url('https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css');

  // @import '@/sass/config.scss';  
  // @import '@/sass/base/mixins.scss';
  // @import '@/sass/components/nav/nav.scss';
  // @import '@/sass/components/nav/nav-logo.scss';
  // @import '@/sass/components/nav/nav-desktop.scss';
  // @import '@/sass/components/nav/nav-mobile.scss';
  // @import '@/sass/components/snackbar.scss';
 
 .nav__mega__link__item{
   color:black;
 }
  
</style>